import { render, staticRenderFns } from "./TotalCard.vue?vue&type=template&id=1bc8ed1e&"
import script from "./TotalCard.vue?vue&type=script&lang=js&"
export * from "./TotalCard.vue?vue&type=script&lang=js&"
import style0 from "./TotalCard.vue?vue&type=style&index=0&id=1bc8ed1e&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports